module.exports = __webpack_public_path__ + "img/TPC-Logo.66d95303.png";